//# sourceMappingURL=my-date-range.interface.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/mydatepicker/dist/interfaces/my-date-range.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-date-range.interface.js
// module chunks = 4